import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=8df63d04&scoped=true&"
import script from "./Pdf.vue?vue&type=script&lang=js&"
export * from "./Pdf.vue?vue&type=script&lang=js&"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=8df63d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df63d04",
  null
  
)

export default component.exports